import React from "react";
import { Button, Empty } from "antd";
import CustomerTable from "../customerTable";
import useJDStore from "../../store/jd.store";
import SkillMatrixModal from "../SkillMatrixModal";
import useClientStore from "../../store/clientModal.store";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import useSkillMatrixStore from "../../store/skillMatrix.store";

import "./JDSkillMatrix.scss";
import SkillMatrixTableSelectable from "../SkillMatrixTableSelectable";



function JDSkillMatrix({ selectedJD }) {
  const { value } = useParams();
  //   const { jdSkillMatrix, getJDSkillMatrix } = useJDStore();
  const { setModalOpen } = useSkillMatrixStore();

  console.log("selectedJD", selectedJD);
  const skillMatrixTitles = [
    "Select",
    "S. No.",
    "Skills",
    "Min Exp",
    "Max Rating",
    "Weightage",
  ];
  const skillMatrixData = selectedJD?.JDRequired?.skillmatrix?.map(
    (item, idx) => {
      return {
        select: "",
        id: idx,
        skill: item.skill
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        mentionedexp: item.mentionedexp==0?selectedJD?.JDRequired?.MinExperience:item.mentionedexp,
        selfrating: item.selfrating==0?10:item.selfrating,
        weightage: item.weightage ? "Mandatory" : "Optional",
      };
    },
  );

  const handleAddTeamClick = () => {
    setModalOpen();
  };

  return (
    <div className="jd-skill-matrix-wrapper">
      <h3 className="jd-skill-matrix-title">Skill Matrix</h3>
      <div className="jd-skill-matrix-container">
        <div className="jd-skill-matrix-add-wrapper">
          <Button
            onClick={() => handleAddTeamClick()}
            type="primary"
            className="jd-skill-matrix-add-btn"
          >
            + New Skill
          </Button>
        </div>

        <SkillMatrixTableSelectable
          titleList={skillMatrixTitles}
          data={skillMatrixData}
          qhjid={selectedJD?.QhCompanyJID}
          columnWidth={"50px 50px 2fr 1fr 1fr 1fr"}
        />
      </div>
      <SkillMatrixModal qhjid={selectedJD?.QhCompanyJID} />
    </div>
  );
}

export default JDSkillMatrix;
